// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productAddToListLinkStyles } from "@synd/Overrides/Components/ProductAddToListLink";
import LinkAddToList from "@synd/XDL/Icons/LinkAddToList";
import { createLinkIconStyles } from "@synd/XDL/Utilities";
import { css } from "styled-components";

productAddToListLinkStyles.link = {
    ...createLinkIconStyles({
        icon: LinkAddToList,
        sizeVariant: "xsmall",
        variant: "primary",
        linkStyles: {
            css: css`
                justify-content: flex-end;
            `,
            icon: {
                iconProps: {
                    size: 13,
                    css: css`
                        &,
                        svg {
                            width: 9px;
                        }
                    `,
                },
            },
        },
    }),
};
